import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * ModuleModal component styles
 * @returns {Function}
 */

export const useStyles = makeStyles(() =>
  createStyles({
    moduleModalWrapper: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      position: 'absolute',
      backgroundColor: variables.color.primary.backgroundLighterGray,
      height: 'calc(150vh + 24.2rem)',
      top: '-1px',
      left: '0',
      zIndex: 1,
      padding: '0 0 0 0', // '25rem 7.7rem 0 7.8rem',
      overflowY: 'hidden', //'auto',
      overflowX: 'hidden',
    },

    moduleContent: {
      border: `none ${variables.colorV2.contentModule.border.active} `,
      borderWidth: '0 0 0 0',
      boxSizing: 'content-box',
      position: 'relative',
      width: '60rem',
      minWidth: '60rem',
    },

    iframe: {
      border: 'unset',
      // borderRadius: '2rem',
      // minHeight: '100%',
      overflow: 'hidden',
      width: '100%',

      '&::-webkit-scrollbar': {
        width: variables.scrollbar.width,
        height: variables.scrollbar.height,
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#dfe5eb',
        borderRadius: variables.borderRadius.md,
      },
    },

    closeBtn: {
      padding: '3px 5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      background: variables.colorV2.module.border.default,
      top: '0',
      right: '-2.6rem',
      cursor: 'pointer',
      borderRadius: '.4rem',

      '&:hover': {
        background: variables.colorV2.module.border.default,
      },
    },

    removeBtn: {
      padding: '3px 5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      background: variables.colorV2.module.border.default,
      top: '-2rem',
      right: '3rem',
      cursor: 'pointer',
      borderRadius: '.4rem',

      '&:hover': {
        background: variables.colorV2.module.border.default,
      },
    },
  }),
);
